export default __webpack_public_path__ + "static/media/contact-page-img.564ef623.jpg";